module.exports = __webpack_public_path__ + "img/icon-awesome-clock.fc1bc4e4.svg";